module.exports = __webpack_public_path__ + "media/_archive/Nold-1bd125b3.png";